<template>
  <div class="table_wrap">
    <div class="filter_wrap">
      <div class="filter_row">
        <div class="filter_content language_filter">
          <div class="filter_titleBox mr15">
            <span class="filter_title">언어</span>
          </div>
          <el-select v-model="langOption" class="select faq_select mr5"
                     @change="setFilterArrayFunc('cid', langOption)">
            <el-option :value="''" :label="'전체'"></el-option>
            <el-option v-for="(data, value, index) in languageList" :key="`boardLanguage${value}`"
                       :label="data.c_lang_ko" :value="Number(data.c_idx)"></el-option>
          </el-select>
        </div>
        <div class="filter_content">
          <div class="filter_titleBox mr15">
            <span class="filter_title">작성일</span>
          </div>
          <div class="filter">
            <el-date-picker
                class="datePicker_long"
                v-model="filterDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="setFilterFunc('cr', filterDate)"
                start-placeholder="시작일"
                end-placeholder="종료일"
                :editable="false"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="filter_content ">
          <div class="filter_titleBox mr15">
            <span class="filter_title">제목</span>
          </div>
          <div class="filter">
            <el-input v-model="searchInput" placeholder="검색어를 입력해 주세요." class="shortest mr10" @keypress.enter.native="setFilterFunc('su', searchInput)">
            </el-input>
            <el-button class="com_search" @click="setFilterFunc('su', searchInput)">
              검색
            </el-button>
          </div>
        </div>
      </div>


    </div>
    <div class="filter-show-count mt15 mb15">
      <el-select class="veryShort" v-model="size" @change="changePage('size', size)">
        <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                   :label="`${sizeData}개씩 보기`"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import {appLanguage} from "@/service/languageService"

const {filterConfig} = boardFilterUtil
export default {
  name: "BoardFilterDefaultLayout",
  mixins: [boardFilterUtil],
  components: {},
  provide() {
    return {}
  },
  inject: ['setPage', 'setFilter'],
  props: {
    filterData: {
      default: () => {
        return {}
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return {
      searchInputOption: 'cid',
      searchInput: '',
      filterDate:'',
      size: 10,
      sizeList: [10, 30, 50],
      langOption: '',
      languageList: appLanguage,
    }
  },
  created() {
  },
  mounted() {
    this.setterFilterDataInData();

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
      setterFilterDataInData() {
          let classnames = Object.keys(this.filterData);
          classnames.forEach(classname => {
              let obj = this.filterData[classname];
              let type = filterConfig[obj.key].type;
              if (this.hasOwnProperty(classname)) {
                  if (type == 'query') {
                      this[classname] = obj.query;
                      if (this.hasOwnProperty(classname + 'Option')) {
                          this[classname + 'Option'] = obj.key;
                      }
                  } else if (type === 'between') {
                      this[classname] = [obj.start, obj.end];
                  } else if (type === 'match') {
                      let arr = obj.value.split(',');
                      if (arr.length > 1) {
                          let numArr = []
                          for (let i of arr) {
                              numArr.push(Number(i))
                          };
                          this[classname] = numArr
                      } else if (isNaN(obj.value)) {
                          this[classname] = obj.value;
                      } else {
                          this[classname] = Number(obj.value);
                      }

                  }else if(type === 'terms') {
                      if(isNaN(obj.terms[0])) {
                          this[classname] = obj.terms[0];
                      }else{
                          this[classname] = Number(obj.terms[0]);
                      }

                  }

              }
          })
          this.size = this.paginationData.size;
      },
    setFilterArrayFunc(key, value) {
      let arr = []
      if (!util.isEmpty(value)) {
        arr.push(value)
      }
      this.setFilter(key, arr);
    },
    moveCreate() {
      this.$router.replace(this.$route.path);
      this.$router.push(`/notice/create`);
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },

    checkFilterData() {
      return this.filterDate != null && this.filterDate.length > 0;
    },
    changePage(key, value) {
      this.setPage(key, value);
      this.setPage('page', 1);
    },

    searchFilter(searchInput,value){
      this.setFilterFunc('su', searchInput)
      this.setFilterFunc('cr',value);
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
